// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2eg02","paramInput":"JobSimulator_paramInput__Rw4lB","input":"JobSimulator_input__1tBzI"};